module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Richard Bauckham\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("   "), _c('B', [_vm._v("Richard Bauckham")]), _vm._v(" is professor emeritus at the University of St. Andrews and senior scholar at Ridley Hall, Cambridge. He is a fellow of the British Academy and of the Royal Society of Edinburgh. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Iyjm26/tc-custom/9781467425995.jpg?1731796517413",
      "alt": "This image is the cover for the book Jesus and the Eyewitnesses"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jesus and the Eyewitnesses\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("'Jesus and the Eyewitness' argues that the four Gospels are closely based on the eyewitness testimony of those who knew Jesus. The author challenges the assumption that the accounts of Jesus circulated as 'anonymous community traditions', asserting instead that they were transmitted in the name of the original eyewitnesses. To drive home this controversial point, Bauckham draws on internal literary evidence, the use of personal names in first-century Jewish Palestine, and recent developments in the understanding of oral tradition. Jesus and the Eyewitnesses also taps into the rich resources of modern study of memory, especially in cognitive psychology, refuting the conclusions of the form critics and calling New Testament scholarship to make a clean break with this long-dominant tradition. Finally, Bauckham challenges readers to end the classic division between the 'historical Jesus' and the'Christ of faith', proposing instead the 'Jesus of testimony' as presented by the Gospels. Sure to ignite heated debate on the precise character of the testimony about Jesus, Jesus and the Eyewitnesses is a groundbreaking work that will be valued by scholars, students, and all who seek to understand the origins of the Gospels.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0